export default __webpack_public_path__ + "static/CustDevelopment-c6e30c48ed1e033aefedfcef12427707.png";